import { gql } from '@apollo/client';

export default gql`
  query GetMediaItemStats($courseId: String!, $studentId: String!) {
    mediaStats(courseId: $courseId, studentId: $studentId)
      @rest(
        type: "StudentMediaStatsPayload"
        path: "courses/{args.courseId}/students/{args.studentId}/media-stats"
      ) {
      totalViews
      avgProgressPercentage
      maxProgressPercentage
      mediaItems {
        _id
        name
        thumbUrl
        totalViews
        duration
        avgProgressPercentage
        maxProgressPercentage
        subject {
          _id
          name
        }
      }
    }
  }
`;
